import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { TeamsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaTeamResolver_Get = TeamsTableDefinitionZod.nullable();

export type SchemaTeamResolver_Get = z.infer<typeof schemaTeamResolver_Get>;

export type TeamResolver_Get = Resolver<Arguments, SchemaTeamResolver_Get>;
